import type { Page } from "@folio/powersync";
import {
  buildDataset,
  type ExportColumn,
  type ExportDataset,
  type ExportMetadata,
} from "@fleet/export";

/**
 * Folio adapter: maps a list of `page` (note) records into the generic
 * {@link ExportDataset}. This is the ONLY note-specific piece — it mirrors the
 * canon `buildTodoDataset` shape (see K1 propagation notes).
 *
 * Booleans stored as 0/1 integers in SQLite are normalized to "Yes"/"No";
 * date/text columns pass through as-is (the consumer can localize).
 */

function yesNo(value: number | null | undefined): string {
  return value === 1 ? "Yes" : "No";
}

export const PAGE_EXPORT_COLUMNS: ExportColumn<Page>[] = [
  { key: "title", header: "Title", accessor: (p) => p.title ?? "" },
  { key: "icon", header: "Icon", accessor: (p) => p.icon ?? "" },
  { key: "is_shared", header: "Shared", accessor: (p) => yesNo(p.is_shared) },
  { key: "created_at", header: "Created", accessor: (p) => p.created_at ?? "" },
  { key: "updated_at", header: "Updated", accessor: (p) => p.updated_at ?? "" },
];

/**
 * Builds an {@link ExportDataset} from a list of pages/notes, ready for
 * `datasetToCsv` / `datasetToHtml`.
 */
export function buildPageDataset(
  pages: readonly Page[],
  metadata: ExportMetadata = {},
): ExportDataset {
  return buildDataset(PAGE_EXPORT_COLUMNS, pages, {
    title: "Pages",
    ...metadata,
  });
}
